import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Paper from '@mui/material/Paper';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';

import LogoUrl from '../../../../resources/logo.svg';
import FullscreenIconUrl from '../../../../resources/icons/icon-fullscreen-black.svg';
import ToolsIconUrl from '../../../../resources/icons/icon-tools-black.svg';
import ZoomIconUrl from '../../../../resources/icons/icon-zoom-black.svg';
import DownloadIconUrl from '../../../../resources/icons/icon-download-black.svg';
import ShareButton from './ShareButton';

import {
  WEBSITE_URL,
  LINKS,
  DOWNLOAD_TEXT,
  MENU_MOBILE_FOOTER_HEIGHT,
  PDF_MENU,
  PDF_NAME_HR
} from '../../../../config';

import styles from '../styles';
import parse from '../../../../utils/parse';
import { Divider } from '@mui/material';

class MobileAppMenu extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentHighlightedItem: null,
      swipeMenuOpen: false,
    };
  }
  /**
   * HANDLE
   */
  handleNavigate(page) {
    const { onNavigate } = this.props;
    this.setState({ swipeMenuOpen: false });
    onNavigate(page);
  }

  isMenuItemActive(item, page) {
    if (!item?.pages?.length) {
      return false;
    }

    const [start, end = start] = item.pages;
    return page >= start && page <= end;
  }
  /**
   * RENDER
   */
  renderHeader() {
    const { classes, onToggleFullscreen, onZoom } = this.props;
    return (
      <AppBar
        className={classes.mobileMenuHeader}
        elevation={0}
        color="inherit"
        position="fixed"
      >
        <Toolbar disableGutters>
          <Stack sx={{ width: '100%', height: '100%' }} direction="row" justifyContent="center" alignItems="center" spacing={2}>
            <a href={WEBSITE_URL} target="_blank" rel="noopener noreferrer">
              <img src={LogoUrl} alt="Luciole" />
            </a>
            <Box sx={{ flex: 1 }}></Box>
            <Stack alignItems="center">
              <Stack direction="row">
                <IconButton onClick={() => onToggleFullscreen(true)}>
                  <img className={classes.menuIcon} src={FullscreenIconUrl} alt="Plein écran" />
                </IconButton>
                <IconButton onClick={() => onZoom()}>
                  <img className={classes.menuIcon} src={ZoomIconUrl} alt="Zoom" />
                </IconButton>
                <IconButton onClick={() => this.setState({ currentHighlightedItem: 'MENU', swipeMenuOpen: true })}>
                  <img className={classes.menuIcon} src={ToolsIconUrl} alt="Menu" />
                </IconButton>
              </Stack>
            </Stack>
          </Stack>
        </Toolbar>
      </AppBar>
    );
  }

  renderQuickMenu() {
    const { classes, page } = this.props;

    if (!PDF_MENU.length) {
      return null;
    }

    return (
      <Stack className={classes.mobileQuickMenu} spacing={1}>
        <Typography className={classes.mobileQuickMenuTitle}>
          Menu
        </Typography>
        <Stack className={classes.mobileQuickMenuScroll}>
          {PDF_MENU.map((menuItem) => (
            <ListItem key={menuItem.label} disablePadding>
              <ListItemButton
                className={`${classes.mobileQuickMenuItem} ${this.isMenuItemActive(menuItem, page) ? 'active' : ''}`}
                onClick={() => this.handleNavigate(menuItem.pages[0])}
              >
                <ListItemText primary={<Typography>{menuItem.label}</Typography>} />
              </ListItemButton>
            </ListItem>
          ))}
        </Stack>
      </Stack>
    );
  }

  renderFooter(){
    const { classes, page } = this.props;
    const { currentHighlightedItem, swipeMenuOpen } = this.state;

    const color = (currentHighlightedItem && currentHighlightedItem.color) || 'primary';

    return (
      <div className={`${classes.mobileMenuFooter} ${swipeMenuOpen ? 'swipeMenuOpen' : ''} ${color} ${LINKS[page] ? 'pageHasLink' : ''}`}>
        <SwipeableDrawer
          anchor="bottom"
          open={swipeMenuOpen}
          onClose={() => this.setState({ swipeMenuOpen: false })}
          onOpen={() => { }}
          swipeAreaWidth={MENU_MOBILE_FOOTER_HEIGHT}
          disableSwipeToOpen
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            className: `${classes.mobileMenuSwipe} ${classes.subDrawer} ${color}`,
            elevation: 0,
          }}
        >
          <Paper 
            className={classes.mobileMenuSwipePaper} 
            elevation={0} 
            sx={{ backgroundColor: currentHighlightedItem && currentHighlightedItem !== 'MENU' ? '' : `primary !important` }}
            >
            <Box className={classes.mobileMenuPuller} />
            {currentHighlightedItem && currentHighlightedItem !== 'MENU' ? (
              <>
                <ListItem className={`${classes.subListItem} ${currentHighlightedItem.color} ${page >= currentHighlightedItem.pages[0] && page <= currentHighlightedItem.pages[1] ? 'focus' : ''}`} disablePadding>
                  <ListItemButton onClick={() => this.handleNavigate(currentHighlightedItem.pages[0])}>
                    <ListItemText
                      className={`${classes.subListItemLabel} ${currentHighlightedItem.color}`}
                      primary={<Typography variant="h3">{parse(currentHighlightedItem.label)}</Typography>}
                      secondary={<span className={`listItemFocus ${currentHighlightedItem.color}`}></span>}
                    />
                  </ListItemButton>
                </ListItem>
              </>
            ) : (
              <>
                <Stack className={classes.mobileMenuContent} direction="column" spacing={2}>
                  {this.renderQuickMenu()}
                  <Stack className={classes.mobileMenuActions} spacing={2}>
                    <Divider sx={{ bgcolor: "black.main", width: "100%" }} />
                    <ShareButton classes={classes} isMobile />
                    <ListItem key="download" className={classes.listItem} disablePadding sx={{ justifyContent: 'center' }}>
                      <ListItemButton
                        className={classes.shareAndDownloadMobileButton}
                        sx={{ flexGrow: 0 }}
                        onClick={() => {
                          const link = document.createElement("a");
                          link.href = `${window.location.pathname}${PDF_NAME_HR}`;
                          link.download = 'LUCIOLE-Portfolio-sante-2026.pdf';
                          link.click();
                          if (window.umami) {
                            window.umami.track('Portfolio Santé 2026 - Download');
                          }
                        }}
                      >
                        <ListItemIcon>
                            <img className={classes.menuIcon} src={DownloadIconUrl} alt={DOWNLOAD_TEXT} />
                        </ListItemIcon>
                          <ListItemText className={classes.drawerLabel} primary={<Typography variant="h4">{DOWNLOAD_TEXT}</Typography>} />
                      </ListItemButton>
                    </ListItem>
                  </Stack>
                </Stack>
              </>
            )}
          </Paper>
        </SwipeableDrawer>
        {/* <Stack className={classes.mobileMenuFooterContent} direction="row" alignItems="flex-end" justifyContent="space-evenly" spacing={2}>
          {LINKS[page] && 
            <div className={`${classes.mobileMenuButtonWrapper} `}>
              <a href={LINKS[page].url} target="_blank" className={classes.mobileMenuFooterLink} rel="noreferrer">
                {LINKS[page].title}
              </a>
            </div>
          }
        </Stack> */}
      </div>
    );
  }

  render() {
    return (
      <>
        {this.renderHeader()}
        {this.renderFooter()}
      </>
    );
  }
}

MobileAppMenu.propTypes = {
  // props
  categoryOpen: PropTypes.string,
  // funcs
  onNavigate: PropTypes.func.isRequired,
  onToggleFullscreen: PropTypes.func.isRequired,
  onZoom: PropTypes.func.isRequired,
}

export default withStyles(styles)(MobileAppMenu);
